import {styled} from '@mui/system';

export const IconContainer = styled('span')(({theme}) => ({
  display: 'inline-flex',
  alignItems: 'center',
  maxWidth: '100%',
  gap: '.5rem',
}));
